module.exports = __webpack_public_path__ + "assets/img/profit-bg.502a7615.png";